module.exports = __webpack_public_path__ + "img/duanwu_ps_08.55140ac2.jpg";